export const RESET = 'EXSBMEASURE_LIST_RESET'
export const SET_ITEMS = 'EXSBMEASURE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBMEASURE_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBMEASURE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBMEASURE_LIST_TOGGLE_LOADING'
